/**
 * Project : workspace
 * File    : SelectBusinessTypeScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.onboard.select_business_type

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.businessType.viewModel.BusinessTypeViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import component.button.DefaultButton
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import navigation.route.business.BusinessNavRoute
import presentation.screens.business.onboard.component.BusinessTypeCard
import theme.ThemeColor

/**
 * Represents the select business type screen class.
 */

class SelectBusinessTypeScreen{


    @Composable
    fun Content() {

        val viewModel = BusinessTypeViewModel()
        val businessTypes = viewModel.allBusinessType.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.retrieve()
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)

        ) {
            TopNavBar(
                title = localization().businessList.selectBusiness,
                onBackPress = {
                    AppNavigator.shared().goBack()
                })
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 180.dp), //width
                modifier = Modifier.weight(1f).padding(
                    start = 8.dp,
                    end = 8.dp,
                    bottom = if (businessTypes.value.isNotEmpty()) 60.dp else (60.dp)
                ),
            ) {
                items(businessTypes.value.count()) { index ->
                    BusinessTypeCard(businessType = businessTypes.value[index], onClick = {
                        AppNavigator.shared().navigate(BusinessNavRoute.CREATE,NavigationParam(businessType = it))
                    })
                }
                item {
                    DefaultButton("Create Business Type", {
                        AppNavigator.shared().navigate(BusinessNavRoute.BUSINESS_TYPE_CREATE)
                    })
                }
                }

            }
        }
    }